<script>
import { BCalendar } from "bootstrap-vue";

export default {
  extends: BCalendar
};
</script>